interface PortalAppDisplayName {
  name: string;
  display_name_zh: string;
  display_name_en: string;
}

/** 数据迁移滚动发布期间，确保门户统一使用新的平台应用名称。 */
export function normalizePortalAppDisplayName<T extends PortalAppDisplayName>(app: T): T {
  if (app.name === 'agent') {
    return {
      ...app,
      display_name_zh: '智能中心',
      display_name_en: 'Agent Center',
    };
  }
  if (app.name !== 'admin') return app;
  return {
    ...app,
    display_name_zh: 'CREST平台',
    display_name_en: 'CREST Platform',
  };
}
